export class PreparacionEvaluacion {
    puestoid: number = 0;
    nombre: string = "";
    periodoevaluacionid: number = 0;
    departamento: string = "";
    departamentoid: number = 0;
    fechaedicion: any = "";
    usuario: string = "";
    usuarioanterior: string = "";
    
    constructor(init?: Partial<PreparacionEvaluacion>) {
        Object.assign(this, init);
    }
    
    }